import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const ExposeDownloadIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='96'
      height='97'
      viewBox='0 0 96 97'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1206_8374)'>
        <path
          d='M79.036 48.5754C78.235 48.3196 77.4227 48.1053 76.5729 47.8609V0H75.5349C54.6036 0 33.6684 0 12.7333 0C5.48292 0.00376058 0.0752115 5.39643 0.0676904 12.6393C0.0376058 35.921 0.0150423 59.2065 0 82.492C0 83.3344 0.00752116 84.1918 0.154184 85.0154C1.33124 91.6829 6.68254 96.1429 13.4929 96.1429C32.796 96.1504 52.1028 96.1542 71.4058 96.1316C72.8085 96.1316 74.2263 96.015 75.6102 95.7856C86.591 93.9693 95.1539 84.7521 95.9323 73.963C96.7709 62.3353 89.9492 52.0802 79.036 48.5754V48.5754ZM22.7327 5.69727H70.8831V47.2968C69.2059 47.5638 67.555 47.7292 65.9492 48.0978C56.1003 50.3729 48.5378 58.8718 47.4246 68.875C47.3607 69.4541 47.2366 69.7625 46.5409 69.7587C38.8355 69.7361 31.1263 69.7437 23.4209 69.7399C23.2065 69.7399 22.9959 69.6948 22.7289 69.6647V5.69727H22.7327ZM12.8612 5.63334C14.2037 5.62958 15.5462 5.63334 16.9828 5.63334V69.7549C13.0755 69.6684 9.20213 69.5744 5.75744 72.0978C5.73488 71.6202 5.70479 71.3231 5.70479 71.026C5.70479 51.6252 5.70479 32.2244 5.70479 12.8236C5.70479 8.46882 8.51771 5.64463 12.8574 5.63334H12.8612ZM55.2504 90.5284C41.2159 90.5284 27.1852 90.5472 13.1507 90.5133C9.33375 90.5058 6.09966 87.6101 5.70103 84.0113C5.25353 79.9762 7.65277 76.4713 11.5262 75.5876C12.282 75.4146 13.0793 75.377 13.8577 75.377C24.7258 75.3657 35.5976 75.377 46.4657 75.3469C47.3081 75.3469 47.5638 75.6064 47.6954 76.4149C47.8947 77.6409 48.2896 78.833 48.6393 80.1717H14.4143V85.8088H15.5124C27.2266 85.8088 38.9445 85.8164 50.6587 85.79C51.4372 85.79 51.8772 86.0533 52.3585 86.6399C53.4227 87.9448 54.5998 89.1595 55.7618 90.4419C55.6302 90.4644 55.4384 90.5246 55.2504 90.5246V90.5284ZM71.6691 90.5133C61.3012 90.5246 52.8887 82.146 52.8812 71.7969C52.8737 61.4441 61.2636 53.0505 71.6315 53.0429C81.943 53.0354 90.3328 61.3914 90.3742 71.7142C90.4193 82.0558 82.0144 90.4983 71.6691 90.5133Z'
          fill={stroke}
        />
        <path
          d='M62.8502 28.821H31.3779V34.3341H62.8502V28.821Z'
          fill={stroke}
        />
        <path
          d='M56.4799 16.6067H37.7334V22.1047H56.4799V16.6067Z'
          fill={stroke}
        />
        <path
          d='M74.4483 72.5491V60.7333H68.7773V72.5867C68.672 72.6468 68.563 72.7033 68.4577 72.7634C67.4386 71.6353 66.4232 70.5071 65.4267 69.4052C64.039 70.8042 62.7642 72.0903 61.542 73.3162C64.8851 76.6556 68.2885 80.0514 71.594 83.357C74.9296 80.0289 78.333 76.6331 81.5783 73.3914C80.3524 72.1617 79.0588 70.8681 77.5545 69.3601C76.5843 70.3529 75.5313 71.4284 74.4408 72.5415L74.4483 72.5491Z'
          fill={stroke}
        />
      </g>
      <defs>
        <clipPath id='clip0_1206_8374'>
          <rect width='96' height='96.1504' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
